// Orivane Hair Care — Theme JS

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initMobileNav();
  initCartDrawer();
  initAccordions();
  initGallery();
  initAnimations();
  initSearch();
});

// ── Header scroll effect ──────────────────────────
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 40);
  }, { passive: true });
}

// ── Mobile nav ────────────────────────────────────
function initMobileNav() {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav = document.querySelector('.mobile-nav');
  const close = document.querySelector('.mobile-nav-close');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', () => { nav.classList.add('open'); document.body.style.overflow = 'hidden'; });
  close?.addEventListener('click', closeNav);
  nav.addEventListener('click', e => { if (e.target === nav) closeNav(); });

  // Sluit menu na klikken op een link
  nav.querySelectorAll('a').forEach(a => a.addEventListener('click', closeNav));

  function closeNav() { nav.classList.remove('open'); document.body.style.overflow = ''; }
}

// ── Cart drawer ───────────────────────────────────
function initCartDrawer() {
  const overlay = document.querySelector('.cart-overlay');
  const drawer = document.querySelector('.cart-drawer');
  const closeBtn = document.querySelector('.cart-close');
  const cartBtns = document.querySelectorAll('[data-open-cart]');

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  overlay?.addEventListener('click', closeCart);
  closeBtn?.addEventListener('click', closeCart);

  function openCart() {
    refreshCartDrawer().then(() => {
      overlay?.classList.add('open');
      drawer?.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeCart() {
    overlay?.classList.remove('open');
    drawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Delegated qty buttons in cart drawer
  document.addEventListener('click', async e => {
    const btn = e.target.closest('.qty-btn[data-line]');
    if (!btn) return;
    const line = parseInt(btn.dataset.line);
    const action = btn.dataset.action;
    const currentQty = parseInt(btn.parentElement.querySelector('.qty-value').textContent);
    const newQty = action === 'minus' ? Math.max(0, currentQty - 1) : currentQty + 1;

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: newQty })
      });
      await refreshCartDrawer();
    } catch {
      showToast('Er ging iets fout. Probeer opnieuw.', 'error');
    }
  });
}

// Haalt de cart op en hertekent de drawer volledig
async function refreshCartDrawer() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Update count badge
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
    });

    const itemsEl = document.querySelector('.cart-drawer__items');
    const footerEl = document.querySelector('.cart-drawer__footer');
    if (!itemsEl) return cart;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p style="text-align:center;padding:48px 0;font-size:14px;color:var(--color-text-muted);">Je winkelwagen is leeg.</p>';
      if (footerEl) footerEl.style.display = 'none';
      return cart;
    }

    itemsEl.innerHTML = cart.items.map((item, i) => `
      <div class="cart-item">
        <div class="cart-item__image">
          <a href="${item.url}">
            <img src="${item.featured_image?.url || ''}" alt="${item.title}" width="80" height="80" style="object-fit:cover;">
          </a>
        </div>
        <div class="cart-item__details">
          <div class="cart-item__title"><a href="${item.url}">${item.product_title}</a></div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__qty">
            <button class="qty-btn" data-action="minus" data-line="${i + 1}" aria-label="Minder">−</button>
            <span class="qty-value">${item.quantity}</span>
            <button class="qty-btn" data-action="plus" data-line="${i + 1}" aria-label="Meer">+</button>
          </div>
        </div>
        <div>
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
          <button class="qty-btn" data-action="minus" data-line="${i + 1}" style="font-size:10px;margin-top:6px;letter-spacing:0.06em;color:var(--color-text-muted);" onclick="this.dataset.action='remove'" aria-label="Verwijder">Verwijder</button>
        </div>
      </div>
    `).join('');

    // Verwijder knop fix
    itemsEl.querySelectorAll('.qty-btn[style]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = parseInt(btn.dataset.line);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: 0 })
        });
        await refreshCartDrawer();
      });
    });

    if (footerEl) {
      footerEl.style.display = '';
      const sub = footerEl.querySelector('.cart-subtotal strong');
      if (sub) sub.textContent = formatMoney(cart.total_price);
    }

    return cart;
  } catch {
    return null;
  }
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
}

// ── Toast notificatie ─────────────────────────────
function showToast(message, type = 'success') {
  const existing = document.querySelector('.orivane-toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.className = 'orivane-toast';
  toast.setAttribute('role', 'status');
  toast.innerHTML = `
    <span style="display:inline-block;width:6px;height:6px;border-radius:50%;background:${type === 'error' ? '#ef4444' : '#22c55e'};margin-right:10px;flex-shrink:0;"></span>
    ${message}
  `;
  document.body.appendChild(toast);

  requestAnimationFrame(() => toast.classList.add('toast-visible'));
  setTimeout(() => {
    toast.classList.remove('toast-visible');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// ── Accordion ─────────────────────────────────────
function initAccordions() {
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const body = trigger.nextElementSibling;
      const icon = trigger.querySelector('.accordion-icon');
      const isOpen = body.classList.contains('open');

      document.querySelectorAll('.accordion-body.open').forEach(b => b.classList.remove('open'));
      document.querySelectorAll('.accordion-icon').forEach(i => i.textContent = '+');

      if (!isOpen) {
        body.classList.add('open');
        if (icon) icon.textContent = '−';
      }
    });
  });
}

// ── Product gallery thumbnails ────────────────────
function initGallery() {
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.product-gallery__main img');
      if (main && thumb.dataset.src) {
        main.src = thumb.dataset.src;
        document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });
}

// ── Scroll animations ─────────────────────────────
function initAnimations() {
  const els = document.querySelectorAll('[data-animate]');
  if (!els.length) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  els.forEach(el => observer.observe(el));
}

// ── Zoekfunctie ───────────────────────────────────
function initSearch() {
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchOverlay = document.querySelector('.search-overlay');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('.search-overlay__input');

  if (!searchToggle || !searchOverlay) return;

  searchToggle.addEventListener('click', () => {
    searchOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 100);
  });

  const close = () => {
    searchOverlay.classList.remove('open');
    document.body.style.overflow = '';
  };

  searchClose?.addEventListener('click', close);
  searchOverlay.addEventListener('click', e => { if (e.target === searchOverlay) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
}

// ── Add to cart (AJAX) ────────────────────────────
async function addToCart(variantId, quantity = 1) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) })
    });
    if (!res.ok) throw new Error();
    await refreshCartDrawer();
    document.querySelector('.cart-overlay')?.classList.add('open');
    document.querySelector('.cart-drawer')?.classList.add('open');
    document.body.style.overflow = 'hidden';
    showToast('Product toegevoegd aan winkelwagen');
  } catch {
    showToast('Kon product niet toevoegen. Probeer opnieuw.', 'error');
  }
}

// ── Cart pagina AJAX qty ──────────────────────────
document.addEventListener('click', async e => {
  const btn = e.target.closest('.cart-page-qty-btn');
  if (!btn) return;
  e.preventDefault();
  const line = parseInt(btn.dataset.line);
  const action = btn.dataset.action;
  const row = btn.closest('.cart-page-item');
  const currentQty = parseInt(row?.querySelector('.cart-page-qty-value')?.textContent || '1');
  const newQty = action === 'minus' ? Math.max(0, currentQty - 1) : currentQty + 1;

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: newQty })
    });
    const cart = await res.json();

    if (newQty === 0) {
      row?.remove();
    } else {
      const qtyEl = row?.querySelector('.cart-page-qty-value');
      if (qtyEl) qtyEl.textContent = newQty;
      const priceEl = row?.querySelector('.cart-page-item-price');
      const item = cart.items[line - 1];
      if (priceEl && item) priceEl.textContent = formatMoney(item.final_line_price);
    }

    const totalEl = document.querySelector('.cart-page-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
    });
  } catch {
    showToast('Er ging iets fout.', 'error');
  }
});

// ── Product pagina form submit ────────────────────
document.addEventListener('submit', async e => {
  if (e.target.matches('[data-add-to-cart-form]')) {
    e.preventDefault();
    const form = e.target;
    const variantId = form.querySelector('[name="id"]')?.value;
    const qty = form.querySelector('[name="quantity"]')?.value || 1;
    const btn = form.querySelector('.add-to-cart-btn');

    if (!variantId) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Wordt toegevoegd...'; }

    await addToCart(variantId, qty);

    if (btn) {
      btn.disabled = false;
      btn.textContent = 'Toevoegen aan winkelwagen';
    }
  }
});
